import React, { useEffect, useState } from 'react'
import { Badge, Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon,   } from '../../../../components/Component'
import   ReactDataTable   from './ReactDataTable/ReactDataTable'
import { WEBSITE_BASE_URL } from '../../../../config'
import ToastExample from '../../../../helpers/toast'
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import moment from 'moment'
import { getAllCustomers, getAllStoreOwner } from '../../../../redux/admin/user/action'
import { useDispatch, useSelector } from 'react-redux'
import { Image, Table } from 'antd'
import noimage from '../../../../assets/images/noimage.png'
import { ColorRing } from 'react-loader-spinner'



function Customer() {

    const dispatch = useDispatch();

    // get data from redux state
    const getSelectors = (state) => ({
        users: state.users.customers,
    });

    const { users } = useSelector(getSelectors);

    // get all users  onload
    useEffect(() => {
        dispatch(getAllCustomers()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false)
            }
        })
    }, [])
    const [usersTableDatas, setUsersTableDatas] = useState([]); // for deleting addon
    const [loading, setLoading] = useState(true);

    const dataTableColumns = [
        {
            name: "ID",
            selector: (row) => row.id,
            sortable: true,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            cell: (row) => (
                <div className="user-card">
                    {row.image &&
                        <Image
                            style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                overflow: "hidden",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                            }}
                            src={row?.image ? row?.image : noimage}
                        />
                    }
                    <div style={{
                        marginLeft: "10px",
                    }}>
                        <span className="">
                            {row.name}
                        </span>
                    </div>
                </div>
            )
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
        },
        {
            name: "Phone",
            selector: (row) => row.phone,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Badge className="badge-dot" color={row?.is_active == '1' ? "success" : "danger"}>
                    {row?.is_active == '1' ? "Active" : "In Active"}
                </Badge>
            )
        },
        {
            name: "Role",
            selector: (row) => row.phone,
            sortable: true,
            cell: (row) => (
                <Badge pill color="secondary">
                    {row?.roles && row?.roles[0] ? row?.roles[0]?.name : "User Has No Role"}
                </Badge>
            )
        },
        {
            name: "Created At",
            selector: (row) => row.created_at ? moment(row.created_at).fromNow() : moment().fromNow(),
            sortable: true,
        },

        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];

    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" href={'/edit-user/' + row.id}>
                                <Icon name="pen" />
                                Edit
                            </DropdownItem>
                        </li>


                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Customers "></Head>

                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Customers
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {users.length} Customers .</p>
                                    </BlockDes>
                                </BlockHeadContent>

                            </BlockBetween>
                        </BlockHead>
                        <ReactDataTable data={users} columns={dataTableColumns} expandableRows pagination />
                    </Content>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default Customer
